"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Skeleton = void 0;
var _react = _interopRequireDefault(require("react"));
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _Cell = require("../Comparison/Cell");
var _Row = require("../Comparison/Row");
require("../Comparison/Comparison.scss");
require("./Skeleton.scss");
const MAX_NUMBER_OF_PRODUCTS = 4;
const NUMBER_OF_FEATURE_ROWS = 8;
const NUMBER_OF_ATTRIBUTES_GROUPS_ROWS = 2;
const NUMBER_OF_ATTRIBUTES_ROWS = 4;
const Skeleton = _ref => {
  let {
    numberOfProducts = MAX_NUMBER_OF_PRODUCTS,
    className
  } = _ref;
  const columns = numberOfProducts >= 1 ? numberOfProducts <= MAX_NUMBER_OF_PRODUCTS ? numberOfProducts : MAX_NUMBER_OF_PRODUCTS : 1;
  const cellClassName = 'cds-ComparisonTable-Cell';
  const rootClassName = (0, _classnames.default)('cds-Skeleton-Wrapper--Pulse', `cds-Comparison--${Math.max(2, columns)}Columns`, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement("h1", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-Skeleton--TextH1 cds-Skeleton--TextShort"
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-Skeleton--TextLong"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ProductComparePage-ActionButtons cds-Skeleton--TextLong"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-ComparisonTable cds-ComparisonSkeleton"
  }, /*#__PURE__*/_react.default.createElement(_Row.Row, {
    className: "cds-ComparisonTableHeaderRow"
  }, [...Array(columns).keys()].map(index => /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
    className: cellClassName,
    id: `${index}`,
    key: (0, _key.createKey)(index, 'comparison-column')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Skeleton--ImageFull"
  }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Skeleton--TextH5 cds-Skeleton--TextFull"
  }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Skeleton--TextMedium"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Skeleton--TextMedium"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Skeleton--TextMedium"
  }), /*#__PURE__*/_react.default.createElement("br", null), [...Array(NUMBER_OF_FEATURE_ROWS).keys()].map(key => /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-ComparisonTableRow",
    key: key
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Comparison-Features-AttrLabel cds-Skeleton--TextShort",
    style: {
      width: '50%'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Comparison-Features-AttrValue cds-Skeleton--TextLong",
    style: {
      width: '50%'
    }
  }))), /*#__PURE__*/_react.default.createElement("br", null))), columns === 1 && /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
    className: cellClassName,
    id: "cell-empty"
  })), [...Array(NUMBER_OF_ATTRIBUTES_GROUPS_ROWS).keys()].map(index => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: (0, _key.createKey)(index, 'comparison-attributes')
  }, /*#__PURE__*/_react.default.createElement(_Row.Row, {
    isLabel: true,
    isPrimary: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Skeleton--TextLong"
  })), /*#__PURE__*/_react.default.createElement(_Row.Row, {
    isLabel: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Skeleton--TextLong"
  })), /*#__PURE__*/_react.default.createElement(_Row.Row, null, [...Array(columns).keys()].map(index => /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
    id: `${index}`,
    key: (0, _key.createKey)(index, 'comparison-attribute-values'),
    className: cellClassName
  }, [...Array(NUMBER_OF_ATTRIBUTES_ROWS).keys()].map(index => /*#__PURE__*/_react.default.createElement("div", {
    key: (0, _key.createKey)(index, 'comparison-details-row'),
    className: (0, _classnames.default)('cds-Skeleton--TextShort', {
      'cds-Skeleton--TextMicro': columns <= 2
    })
  })))), columns === 1 && /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
    className: cellClassName,
    id: "cell-empty"
  }))))));
};
exports.Skeleton = Skeleton;
//# sourceMappingURL=Skeleton.js.map